<template>
  <v-app>
    <!-- 根据应用组件来调整你的内容 -->
    <v-main>
      <!-- 给应用提供合适的间距 -->
      <v-container style="height: 100%" fluid>
        <!-- 如果使用 vue-router -->
        <router-view :key="key"></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import systemConfig from "@/configs/system";
export default {
  name: "AppView",
  computed: {
    key() {
      return this.$route.path;
    },
  },
  data: () => ({
    mini: false,
    systemConfig,
  }),
  methods: {},
};
</script>
